import { BaseProps, Dialog, DialogBody, DialogTitle } from '@/components/base/dialog'
import { Form as NewForm } from './new_form'
import { CustomFieldValueAttributes } from '@/types'

interface Props extends BaseProps {
  defaultValues?: Partial<CustomFieldValueAttributes>
}

export const NewDialog = ({ defaultValues, open, setOpen }: Props) => {
  return (
    <>
      <Dialog open={open} size="3xl" onClose={setOpen}>
        <DialogTitle>New custom field</DialogTitle>
        <DialogBody>
          <NewForm defaultValues={defaultValues} onSuccess={() => setOpen(false)} />
        </DialogBody>
      </Dialog>
    </>
  )
}
